import { getCurrentUser, getUserPreferences, setUserPreferences, getUsers } from "@/api/users";
import { queryOptions } from "@tanstack/react-query";

const usersQueries = {
  all: () => ["users"] as const,
  lists: () => [...usersQueries.all(), "list" as const] as const,
  list: () =>
    queryOptions({
      queryKey: [...usersQueries.lists()] as const,
      queryFn: getUsers,
    }),
  preferences: () =>
    queryOptions({
      queryKey: [...usersQueries.all(), "userPreferences"],
      queryFn: getUserPreferences,
    }),
  setUserPreferences: (preferences: string) =>
    queryOptions({
      queryKey: [...usersQueries.all(), "setUserPreferences", preferences],
      queryFn: () => setUserPreferences(preferences),
    }),
  currentUser: () =>
    queryOptions({
      queryKey: [...usersQueries.all(), "currentUser"],
      queryFn: getCurrentUser,
      staleTime: 50000,
    }),
};

export default usersQueries;
